// Spec 082 — os tipos do indicador próprio no frontend.
//
// Tudo vem de `z.infer` do contrato: uma frase é (linha, sentido, produto) na tela, na rota e no
// cálculo, e uma cópia local divergiria no primeiro campo novo.
import type {
  IndicatorDefinitionRequest,
  IndicatorDefinitionResponse,
  IndicatorTerm,
  IndicatorTermSide,
  IndicatorTermValue,
  IndicatorValueResponse,
} from "@opus-dt/shared-types";

export type {
  IndicatorDefinitionRequest,
  IndicatorDefinitionResponse,
  IndicatorTerm,
  IndicatorTermSide,
  IndicatorTermValue,
  IndicatorValueResponse,
};

/** O rascunho enquanto o gestor monta a fórmula — antes de virar pedido. */
export interface IndicatorDraft {
  id: string | null;
  name: string;
  baseUnit: string;
  target: number | undefined;
  terms: IndicatorTerm[];
}

export const INDICATOR_DRAFT_VAZIO: IndicatorDraft = {
  id: null,
  name: "",
  baseUnit: "",
  // `undefined`, nunca `0`: um campo numérico com zero literal obriga a apagar antes de digitar.
  target: undefined,
  terms: [],
};
